import { getSectionHeadingPath } from '@utils/apiFunctions.js';
import httpClient from '@utils/httpClient.js';
import { pathTypes } from '@utils/sectionEnums.js';

export function updateHeaderApiCall({
  id,
  isPathDesign,
  isHeader,

  avatarImagePreview,
  avatarUrl,
  profilePicShape,
  profilePicBorder,
  profilePicBorderColor,
  profilePicShadow,
  profilePicShadowColor,
  avatarGradient,
  isDisplayProfilePic,

  socialLinksAlign,
  socialIconStyle,

  avatarSize,
  fullName,
  fullNameSize,
  fullNameBold,
  fullNameImage,

  externalUrl,
  location,
  locationMap,

  headerShortBio,
  shortBioSize,

  headerActionType,
  headerCTABackgroundColor,
  headerCTAIsBorder,
  headerCTALinkId,
  headerCTAOpacity,
  headerCTASite,
  headerCTASiteText,
  headerCTATextColor,
  headerCTAPosition,
  headerCTAButtonIcon,
  CTABorder,
  CTABorderColor,
  CTAShape,
  CTAShadow,
  CTAShadowColor,

  headerCoverActionType,
  headerCoverCTABackgroundColor,
  headerCoverCTAIsBorder,
  headerCoverCTALinkId,
  headerCoverTextPosition,
  headerCoverCTABorderColor,
  headerCoverCTAOpacity,
  headerCoverCTASite,
  headerCoverCTASiteText,
  headerCoverCTATextColor,

  textColor,

  headerLayout,
  headerViewType,
  headerCover,
  headerCoverPosition,
  headerCoverHeight,

  headerCoverType,
  headerCoverVideo,

  headerCoverDarkness,
  isHeaderCoverText,
  headerCoverTitle,
  headerCoverTextColor,
  headerCoverDescription,
  coverCTAMargin,
  coverCTABorder,
  coverCTABorderColor,
  coverCTAShape,
  coverCTAShadow,
  coverCTAShadowColor,

  headerSocialBackgroundColor,
  headerSocialColor,
  headerSocialIsCustom,
  headerSocialOpacity,

  headerSocialBorder,
  headerSocialBorderColor,
  headerSocialShape,

  headerSocialIsActive,

  isVerifiedBadge,

  isActiveButtonCTA,
  isActiveButtonCart,
  isActiveButtonMessage,
  isActiveButtonSubscribe,

  directBackgroundColor,
  directTextColor,
  directPosition,
  directText,
  directIcon,
  directOpacity,
  directShadow,
  directShadowColor,
  directShape,
  directBorder,
  directBorderColor,

  cartBackgroundColor,
  cartTextColor,
  cartOpacity,

  headerSubscribeButtonBackgroundColor,
  headerSubscribeButtonTextColor,
  headerSubscribeButtonText,
  headerSubscribeButtonIcon,
  headerSubscribeButtonPosition,
  headerSubscribeButtonOpacity,
  headerSubscribeButtonShadow,
  headerSubscribeButtonShadowColor,
  headerSubscribeButtonShape,
  headerSubscribeButtonBorder,
  headerSubscribeButtonBorderColor,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.header, isPathDesign), {
    id,
    isHeader,

    fullname: fullName,
    fullnameSize: Number(fullNameSize),
    fullnameBold: fullNameBold,
    fullnameImage: fullNameImage,

    opacity: 0,
    backgroundColor: '#ffffff',

    profilePic: avatarImagePreview ? avatarImagePreview : avatarUrl,
    profilePicShadow: profilePicShadow,
    profilePicShadowColor: profilePicShadowColor,
    profilePicShape: profilePicShape,
    profilePicBorder: profilePicBorder,
    profilePicBorderColor: profilePicBorderColor,
    profilePicSize: Number(avatarSize),
    profilePicGradient: avatarGradient,
    isDisplayProfilePic: isDisplayProfilePic,

    textColor: textColor,
    shortBio: headerShortBio,
    shortBioSize: Number(shortBioSize),

    layout: headerLayout,
    viewType: headerViewType,

    ctaType: headerActionType,
    ctaSite: headerCTASite,
    ctaSiteText: headerCTASiteText,
    ctaBackgroundColor: headerCTABackgroundColor,
    ctaTextColor: headerCTATextColor,
    ctaIsBorder: headerCTAIsBorder,
    ctaOpacity: headerCTAOpacity,
    ctaLinkId: headerCTALinkId,
    ctaIcon: headerCTAButtonIcon,
    ctaPosition: headerCTAPosition,
    ctaBorder: CTABorder,
    ctaBorderColor: CTABorderColor,
    ctaShape: CTAShape,
    ctaShadow: CTAShadow,
    ctaShadowColor: CTAShadowColor,

    coverActionType: headerCoverActionType,
    coverCtaSite: headerCoverCTASite,
    coverCtaSiteText: headerCoverCTASiteText,
    coverCtaBackgroundColor: headerCoverCTABackgroundColor,
    coverCtaTextColor: headerCoverCTATextColor,
    coverCtaIsBorder: headerCoverCTAIsBorder,
    coverCtaBorderColor: headerCoverCTABorderColor,
    coverCtaOpacity: headerCoverCTAOpacity,
    coverCtaLinkId: headerCoverCTALinkId,
    coverTextPosition: Number(headerCoverTextPosition),
    coverCtaMargin: coverCTAMargin,
    coverBorder: coverCTABorder,
    coverBorderColor: coverCTABorderColor,
    coverShape: coverCTAShape,
    coverShadow: coverCTAShadow,
    coverShadowColor: coverCTAShadowColor,

    cover: headerCover,
    coverPosition: headerCoverPosition,
    coverHeight: headerCoverHeight,
    coverType: headerCoverType,
    coverVideo: headerCoverVideo,
    coverIsText: isHeaderCoverText,
    coverTitle: headerCoverTitle,
    coverDescription: headerCoverDescription,
    coverTextColor: headerCoverTextColor,
    coverDarkness: Number(headerCoverDarkness),

    socialAlign: socialLinksAlign,
    socialIconStyle: socialIconStyle,
    socialBackgroundColor: headerSocialBackgroundColor,
    socialColor: headerSocialColor,
    socialOpacity: headerSocialOpacity,
    socialIsCustom: headerSocialIsCustom,
    socialIsActive: headerSocialIsActive,

    socialBorder: headerSocialBorder,
    socialBorderColor: headerSocialBorderColor,
    socialShape: headerSocialShape,

    externalUrl: externalUrl,
    location: location,
    locationMap: locationMap,

    isVerifiedBadge: isVerifiedBadge,

    isActiveButtonMessage: isActiveButtonMessage,
    isActiveButtonSubscribe: isActiveButtonSubscribe,
    isActiveButtonCart: isActiveButtonCart,
    isActiveButtonCTA: isActiveButtonCTA,

    directButtonBackgroundColor: directBackgroundColor,
    directButtonTextColor: directTextColor,
    directButtonText: directText,
    directButtonPosition: directPosition,
    directButtonIcon: directIcon,
    directButtonOpacity: Number(directOpacity),
    directButtonShadow: directShadow,
    directButtonShadowColor: directShadowColor,
    directButtonShape: directShape,
    directButtonBorder: directBorder,
    directButtonBorderColor: directBorderColor,

    cartButtonBackgroundColor: cartBackgroundColor,
    cartButtonTextColor: cartTextColor,
    cartButtonOpacity: Number(cartOpacity),

    subscribeButtonBackgroundColor: headerSubscribeButtonBackgroundColor,
    subscribeButtonTextColor: headerSubscribeButtonTextColor,
    subscribeButtonText: headerSubscribeButtonText,
    subscribeButtonPosition: headerSubscribeButtonPosition,
    subscribeButtonIcon: headerSubscribeButtonIcon,
    subscribeButtonOpacity: headerSubscribeButtonOpacity,
    subscribeButtonShadow: headerSubscribeButtonShadow,
    subscribeButtonShadowColor: headerSubscribeButtonShadowColor,
    subscribeButtonShape: headerSubscribeButtonShape,
    subscribeButtonBorder: headerSubscribeButtonBorder,
    subscribeButtonBorderColor: headerSubscribeButtonBorderColor,
  });
}
